export enum PgEnum {
  html5_inicis = 'html5_inicis', // 이니시스웹표준
  inicis = 'inicis', // 이니시스ActiveX결제창 or API 방식
  kcp = 'kcp', // NHN KCP
  kcp_billing = 'kcp_billing', // NHN KCP 정기결제
  uplus = 'uplus', // 토스페이먼츠 (구 LG U+)
  nice = 'nice', // 나이스페이
  jtnet = 'jtnet', // JTNet
  kicc = 'kicc', // 한국정보통신
  bluewalnut = 'bluewalnut', // 블루월넛
  kakaopay = 'kakaopay', // 카카오페이
  danal = 'danal', // 다날휴대폰소액결제
  danal_tpay = 'danal_tpay', // 다날일반결제
  mobilians = 'mobilians', // 모빌리언스 휴대폰소액결제
  chai = 'chai', // 차이 간편결제
  syrup = 'syrup', // 시럽페이
  payco = 'payco', // 페이코
  paypal = 'paypal', // 페이팔
  eximbay = 'eximbay', // 엑심베이
  naverpay = 'naverpay', // 네이버페이-결제형
  naverco = 'naverco', // 네이버페이-주문형
  smilepay = 'smilepay', // 스마일페이
  alipay = 'alipay', // 알리페이
  paymentwall = 'paymentwall', // 페이먼트월
  tosspay = 'tosspay', // 토스간편결제
  smartro = 'smartro', // 스마트로
  settle = 'settle' // 세틀뱅크
}

export enum PayMethodEnum {
  card = 'card', //  신용카드
  vbank = 'vbank' // 가상계좌
  // trans = 'trans', // 실시간계좌이체
  // phone = 'phone', // 휴대폰소액결제
  // samsung = 'samsung', // 삼성페이
  // kpay = 'kpay', // KPay앱
  // kakaopay = 'kakaopay', // 카카오페이
  // payco = 'payco', // 페이코
  // lpay = 'lpay', // LPAY
  // ssgpay = 'ssgpay', // SSG페이
  // tosspay = 'tosspay', // 토스간편결제
  // cultureland = 'cultureland', // 문화상품권
  // smartculture = 'smartculture', // 스마트문상
  // happymoney = 'happymoney', // 해피머니
  // booknlife = 'booknlife', // 도서문화상품권
  // point = 'point', // 베네피아 포인트 등 포인트 결제
  // wechat = 'wechat', // 위쳇페이
  // alipay = 'alipay', // 알리페이
  // unionpay = 'unionpay', // 유니온페이
  // tenpay = 'tenpay' // 텐페이
}

export enum CurrencyEnum {
  KRW = 'KRW',
  USD = 'USD',
  EUR = 'EUR',
  JPY = 'JPY'
}

export enum PaymentLanguangeEnum {
  en = 'en', // (영어)
  ko = 'ko' // (한국어)
}

// https://chai-iamport.gitbook.io/iamport/sdk/javascript-sdk/payrq
export interface ImPortRequestRequestParameter {
  pg: PgEnum;
  pay_method: PayMethodEnum;
  /* merchant_uid는 발주서 발행의 기반이 되는 QUOTATION(견적서)의 id로 사용하기. */
  merchant_uid: string;
  buyer_name: string;
  amount: number;
  custom_data: Record<string, any>; // 주문 부가정보
  escrow?: boolean;
  name?: string; // 물품명
  tax_free?: number; // 면세금액
  currency?: CurrencyEnum;
  language?: PaymentLanguangeEnum;
  buyer_tel?: string;
  buyer_email?: string;
  buyer_addr?: string;
  buyer_postcode?: string;
  confirm_url?: string; // confirm_process 사용시 가맹점 endpoint url
  notice_url?: string; // 결제별 webhook 수신주소 => deafult : 차이포트 관리자 콘솔에 지정된 주소
  customer_uid?: string; // 비인증결제시 빌링키와 1:1 맵핑되는 가맹점 고객 빌링키

  /* 추가속성 */
  digital?: boolean; // 휴대폰 결제수단인 경우 필수, 제품이 실물이 아닌경우 true;
  vbank_due?: string; // 가상계좌 입금기한, format : YYYYMMDDhhmm
  m_redirect_url?: string; // 결제완료이후 이동할 EndPoint, 모바일에서 필수. 리다이렉트로 결제되는 경우 필수.
  app_scheme?: string; // app에서 webview통해 결제시 앱으로 돌아오기 위한 항목.
  biz_num?: string; // 다날-가상계좌 결제시 필수

  /* 할부 */
  display?: {
    card_quota: number[]; // 할부 가능 range : [] => 일시불 only, [2, 3, 4, 5] =>  일시불 포함 2개월부터 5개월까지 할부 선택가능
  };
}

export interface ImPortRequestResponse {
  apply_num?: string; // 신용카드 승인번호
  bank_name: null;
  buyer_addr: string;
  buyer_email: string;
  buyer_name: string; //주문자명
  buyer_postcode: string; // format : XXX-XXX
  buyer_tel: string; // format : 010-XXXX-XXXX
  card_name: string;
  card_number: string;
  card_quota: number; // 할부
  currency: CurrencyEnum;
  custom_data: string | null;
  imp_uid: string | null; // success = false && 사전 validation 실패시 null
  merchant_uid: string; // 주문번호
  name: string; // 물품명
  paid_amount: number;
  paid_at: string; // Unix Timestamp
  pay_method: PayMethodEnum;
  pg_provider: PgEnum;
  pg_tid: string;
  pg_type: string;
  receipt_url: string; // 매출전표 url
  status: 'ready' | 'paid' | 'failed';
  success: boolean;
  error_code: string;
  error_msg: string;
  emb_pg_provider?: string; // 간편결제 구분코드
  vbank_num?: string; // 가상계좌 입금 계좌번호 (dash 등 기호 포함)
  vbank_name?: string; // 가상계좌 입금 은행
  vbank_holder?: string; // 가상계좌 예금주 // 일부 PG null 반환
  vbank_date?: string; // 가상계좌 입금기한 unix timestamp
}

export enum RequestPaymentResultCode {
  FAIL_INITIALIZE_IAMPORT = 'FAIL_INITIALIZE_IAMPORT', // IMP 초기화 실패
  MISSING_REQUIRED_INFO = 'MISSING_REQUIRED_INFO' // 필수정보 누락
}

export interface RequestPaymentInput
  extends Omit<
    ImPortRequestRequestParameter,
    'custom_data' | 'buyer_name' | 'pg'
  > {
  amount: number;
  pay_method: PayMethodEnum;
  merchant_uid: string;
  custom_data?: Record<string, any>;
  buyer_name?: string;
}

export interface MobilePaymentRedirectionQuery {
  imp_uid: string;
  merchant_uid: string;
  imp_success: 'true' | 'false';
  error_code?: string;
  error_msg?: string;
}
